import { useEffect } from 'react';

/**
 * Public privacy / personal-data consent page for Google Play.
 * In production nginx serves public/privacy-policy.html at this path;
 * this route covers CRA/local and client-side navigation.
 */
const PrivacyPolicy = () => {
    useEffect(() => {
        window.location.replace('/privacy-policy.html');
    }, []);

    return null;
};

export default PrivacyPolicy;
